class CartManager {
  constructor() {
    this.cartBadges = document.querySelectorAll(".cart-badge");
    this.init();
  }

  init() {
    this.updateCartCount();
    this.attachFormListeners();
    this.attachVariantOptions();
    this.observeDOMChanges();
  }

  observeDOMChanges() {
    const observer = new MutationObserver((mutations) => {
      let shouldReattach = false;
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            if (node.matches && node.matches('form.cart-form[action*="cart/add"]')) {
              shouldReattach = true;
            } else if (node.querySelector) {
              const forms = node.querySelectorAll('form.cart-form[action*="cart/add"]');
              if (forms.length > 0) {
                shouldReattach = true;
              }
            }
          }
        });
      });
      
      if (shouldReattach) {
        this.attachFormListeners();
        this.attachVariantOptions();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  attachFormListeners() {
    const forms = document.querySelectorAll('form.cart-form');

    forms.forEach((form) => {
      if (form.dataset.cartListenerAttached) {
        return;
      }
      form.dataset.cartListenerAttached = "true";

      form.addEventListener("submit", async (e) => {
        e.preventDefault();

        const button = form.querySelector(".btn-cart") || form.querySelector(".btn-buy");

        if (!button) {
          return;
        }

        const originalHTML = button.innerHTML;

        if (button.disabled) {
          return;
        }

        button.disabled = true;

        const isBuyButton = button.classList.contains("btn-buy");

        if (!isBuyButton) {
          const cartIcon = button.querySelector(".cart_icon");
          if (cartIcon) {
            button.innerHTML = "";
            button.appendChild(cartIcon.cloneNode(true));
            button.appendChild(document.createTextNode("追加中..."));
          } else {
            button.textContent = "追加中...";
          }
        }

        try {
          const formData = new FormData(form);
          const variantId = formData.get("id");

          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1,
            }),
          });

          if (!response.ok) {
            throw new Error("カートへの追加に失敗しました");
          }

          if (!isBuyButton) {
            // アイコンを保持したままテキストを変更
            const cartIcon = button.querySelector(".cart_icon");
            if (cartIcon) {
              button.innerHTML = "";
              button.appendChild(cartIcon.cloneNode(true));
              button.appendChild(document.createTextNode("追加しました！"));
            } else {
              button.textContent = "追加しました！";
            }
          }

          await this.updateCartCount();

          if (window.cartDrawerInstance) {
            window.cartDrawerInstance.open();
          }

          setTimeout(() => {
            if (!isBuyButton) {
              button.innerHTML = originalHTML;
            }
            button.disabled = false;
          }, 2000);
        } catch (error) {
          if (!isBuyButton) {
            const cartIcon = button.querySelector(".cart_icon");
            if (cartIcon) {
              button.innerHTML = "";
              button.appendChild(cartIcon.cloneNode(true));
              button.appendChild(document.createTextNode("エラー"));
            } else {
              button.textContent = "エラー";
            }
          }

          setTimeout(() => {
            if (!isBuyButton) {
              button.innerHTML = originalHTML;
            }
            button.disabled = false;
          }, 2000);
        }
      });
    });
  }

  attachVariantOptions() {
    // バリエーション選択時のカート追加処理のみ
    // ドロップダウンの開閉は style.js に任せる
    const variantOptions = document.querySelectorAll(".variant-option");

    variantOptions.forEach((option) => {
      if (option.dataset.cartListenerAttached) {
        return;
      }
      option.dataset.cartListenerAttached = "true";

      option.addEventListener("click", async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (option.disabled) {
          return;
        }

        const variantId = option.dataset.variantId;
        const originalText = option.textContent;
        const dropdown = option.closest(".variant-dropdown");

        option.disabled = true;
        option.textContent = "追加中...";

        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1,
            }),
          });

          if (!response.ok) {
            throw new Error("カートへの追加に失敗しました");
          }

          option.textContent = "追加しました！";

          await this.updateCartCount();

          if (window.cartDrawerInstance) {
            window.cartDrawerInstance.open();
          }

          setTimeout(() => {
            option.textContent = originalText;
            option.disabled = false;
            // ドロップダウンを閉じる
            if (dropdown) {
              dropdown.classList.remove("active");
            }
          }, 1500);
        } catch (error) {
          option.textContent = "エラー";

          setTimeout(() => {
            option.textContent = originalText;
            option.disabled = false;
          }, 2000);
        }
      });
    });
  }

  async updateCartCount() {
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();
      const itemCount = cart.item_count || 0;

      this.cartBadges.forEach((badge) => {
        if (itemCount > 0) {
          badge.textContent = itemCount > 99 ? "99+" : itemCount;
          badge.classList.add("is-visible");
        } else {
          badge.textContent = "0";
          badge.classList.remove("is-visible");
        }
      });
    } catch (error) {
      // Silent error handling
    }
  }
}

// Product lineup sorting by metafield order
function sortProductsByOrder() {
  const wrapper = document.querySelector('.product_box_wrap');
  if (!wrapper) return;
  
  const products = Array.from(wrapper.querySelectorAll('.product_box'));
  if (products.length === 0) return;
  
  // Sort by data-order attribute
  products.sort((a, b) => {
    const orderA = a.getAttribute('data-order');
    const orderB = b.getAttribute('data-order');
    
    // Empty or null → Infinity (最後)
    const numA = orderA && orderA.trim() !== '' ? parseFloat(orderA) : Infinity;
    const numB = orderB && orderB.trim() !== '' ? parseFloat(orderB) : Infinity;
    
    return numA - numB; // 昇順
  });
  
  // Update delay-* classes for animation
  products.forEach((product, index) => {
    // Remove all existing delay-* classes
    product.className = product.className.replace(/delay-\d+/g, '').trim();
    // Add new delay class based on sorted position
    product.classList.add(`delay-${index + 1}`);
  });
  
  // Re-append in sorted order
  const fragment = document.createDocumentFragment();
  products.forEach(product => fragment.appendChild(product));
  wrapper.appendChild(fragment);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    sortProductsByOrder();
    window.cartManager = new CartManager();
  });
} else {
  sortProductsByOrder();
  window.cartManager = new CartManager();
}
